/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationDinersLimit200Response
 */
export interface GetReservationDinersLimit200Response {
    /**
     * 
     * @type {number}
     * @memberof GetReservationDinersLimit200Response
     */
    limit: number | null;
}

/**
 * Check if a given object implements the GetReservationDinersLimit200Response interface.
 */
export function instanceOfGetReservationDinersLimit200Response(value: object): value is GetReservationDinersLimit200Response {
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function GetReservationDinersLimit200ResponseFromJSON(json: any): GetReservationDinersLimit200Response {
    return GetReservationDinersLimit200ResponseFromJSONTyped(json, false);
}

export function GetReservationDinersLimit200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationDinersLimit200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'limit': json['limit'],
    };
}

export function GetReservationDinersLimit200ResponseToJSON(json: any): GetReservationDinersLimit200Response {
    return GetReservationDinersLimit200ResponseToJSONTyped(json, false);
}

export function GetReservationDinersLimit200ResponseToJSONTyped(value?: GetReservationDinersLimit200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limit': value['limit'],
    };
}

